import { makeStyles } from '@material-ui/core';

import { neutral, red } from 'shared/styles/colors';

export default makeStyles(theme => ({
  notification: {
    position: 'fixed',
    bottom: '1rem',
    right: '1rem',
    backgroundColor: red[60],
    color: neutral.white,
    padding: '1rem 1.25rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0.25rem 0.75rem rgba(0, 0, 0, 0.15)',
    maxWidth: '20rem',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    [theme.breakpoints.down('sm')]: {
      bottom: '1rem',
      right: '1rem',
      left: '1rem',
      maxWidth: 'none',
    },
  },
  icon: {
    fontSize: '1.25rem',
    color: neutral.white,
    flexShrink: 0,
  },
  notificationText: {
    fontSize: '0.875rem',
    lineHeight: '1.5',
    color: neutral.white,
  },
}));
